import config, { Environment } from '../../../config/config'

export const useFeatureFlag = (): boolean => {
  const isEnabled = config.environment !== Environment.PRODUCTION || config.getAccountSlug() === 'test'
  return isEnabled
}
